export default __webpack_public_path__ + "static/media/image-phone@2x.10674707.webp";